import React, { Component } from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Tooltip,
  Legend,
  Cell
} from "recharts";
import { Popover } from "react-bootstrap";
import ReactDOM from "react-dom";
import Teams from "../../../../../api/Teams";

class SalesSpendingChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      teamName: "",
      positionTop: 0,
      positionLeft: 0,
      showPopover: false
    };
  }

  formatMillions = val => {
    let valStr = (val / 1000000).toFixed(2);
    return `$${valStr}M`;
  };

  onMouseLeave = () => {
    this.setState({
      showPopover: false
    });
  };

  onMouseEnter = (entry, index, e) => {
    const parentNode = ReactDOM.findDOMNode(this.refs["sales-spending-chart"]);
    const parentCoords = parentNode.getBoundingClientRect();

    this.setState({
      showPopover: true,
      positionTop: e.clientY - parentCoords.top - 90,
      positionLeft: e.clientX - parentCoords.left - 25,
      teamName: entry.value
    });
  };

  renderPopover = () => {
    const { teamName, positionTop, positionLeft, showPopover } = this.state;

    if (showPopover === false) {
      return null;
    }

    return (
      <Popover
        id="sales-spending-legend-popover"
        placement="top"
        positionTop={positionTop}
        positionLeft={positionLeft}
      >
        {teamName}
      </Popover>
    );
  };

  render() {
    const colors = Teams.competitiveColors();
    const { data1, data2, teams } = this.props;
    const payload = Object.values(teams).map((team, index) => {
      return {
        value: team,
        type: "square",
        id: `SSCID${index}`,
        color: colors[index % colors.length]
      };
    });

    return (
      <div id="sales-spending-chart" ref="sales-spending-chart">
        <ResponsiveContainer width="100%" height={192}>
          <PieChart
            margin={{
              top: 20,
              left: 0,
              right: 0,
              bottom: 0
            }}
          >
            <text
              x="20%"
              y={10}
              className="recharts-text recharts-label"
              textAnchor="left"
            >
              <tspan dx={-45} dy={0}>
                DIRECT SALES
              </tspan>
            </text>
            <Pie
              id="ssid-1"
              data={data1}
              dataKey="value"
              cx="20%"
              cy="50%"
              innerRadius={40}
              outerRadius={70}
              fill="#8884d8"
            >
              {colors.map((color, i) => (
                <Cell key={i} fill={color} />
              ))}
            </Pie>
            <text
              x="75%"
              y={0}
              className="recharts-text recharts-label"
              textAnchor="left"
            >
              <tspan dx={-49} dy={10}>
                DISTRIBUTORS
              </tspan>
            </text>
            <Pie
              data={data2}
              dataKey="value"
              cx="75%"
              cy="50%"
              innerRadius={40}
              outerRadius={70}
              fill="#8884d8"
            >
              {colors.map((color, i) => (
                <Cell key={i} fill={color} />
              ))}
            </Pie>
            <Tooltip formatter={this.formatMillions} />
            <Legend
              layout="horizontal"
              align="center"
              verticalAlign="bottom"
              payload={payload}
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
            />
          </PieChart>
        </ResponsiveContainer>
        {this.renderPopover()}
      </div>
    );
  }
}

export default SalesSpendingChart;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/charts/sales-spending.js